import React, { useEffect, useState } from 'react'
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';

// Active
import dashboard_menu from './../../assets/images/sidebar_icon/dashboard_menu.svg'
import setting from './../../assets/images/sidebar_icon/setting.svg';
import order from './../../assets/images/sidebar_icon/order.svg';
import Category_active from './../../assets/images/sidebar_icon/Category_active.svg'
import Menu_Active from './../../assets/images/sidebar_icon/menu_active.svg'
import vegetable from './../../assets/images/sidebar_icon/vegetable_active.svg'
import grocery_active from './../../assets/images/sidebar_icon/grocery_active.svg'
import dairy_active from './../../assets/images/sidebar_icon/dairy_active.svg'
import vasan_active from './../../assets/images/sidebar_icon/vasan_inactive.svg'
import farsan_active from './../../assets/images/sidebar_icon/farsan_active.svg'
import farm_active from './../../assets/images/sidebar_icon/farm_active.svg'

// inActive
import dashboard_inactive from './../../assets/images/sidebar_icon/dashboard_inactive.svg'
import setting_inactive from './../../assets/images/sidebar_icon/setting_inactive.svg';
import order_inactive from './../../assets/images/sidebar_icon/order_inactive.svg';
import Category_inactive from './../../assets/images/sidebar_icon/Category_inactive.svg'
import Menu_inactive from './../../assets/images/sidebar_icon/menu_inactive.svg'
import vegetable_inactive from './../../assets/images/sidebar_icon/vegetable_inactive.svg'
import grocery_inactive from './../../assets/images/sidebar_icon/grocery_inactive.svg'
import dairy_inactive from './../../assets/images/sidebar_icon/dairy_inactive.svg'
import vasan_inactive from './../../assets/images/sidebar_icon/vasan_active.svg'
import farsan_inactive from './../../assets/images/sidebar_icon/farsan_inactive.svg'
import farm_inactive from './../../assets/images/sidebar_icon/farm_inactive.svg'

import Logout_active from './../../assets/images/sidebar_icon/Logout_active.svg'
import Logout_inactive from './../../assets/images/sidebar_icon/Logout_inactive.svg'
import LogoutModal from './../../modal/LogoutModal'
import { fetchSidebarMenu } from '../../API/settings';
import { clearSidebarMenu } from '../../redux/sidebarSlice';
import { useDispatch } from 'react-redux';

// Create a mapping of icon keys to imported assets
const iconsMap = {
  dashboard_inactive,
  dashboard_menu,
  setting,
  setting_inactive,
  order,
  order_inactive,
  Category_active,
  Category_inactive,
  Menu_Active,
  Menu_inactive,
  vegetable,
  vegetable_inactive,
  grocery_active,
  grocery_inactive,
  dairy_active,
  dairy_inactive,
  vasan_active,
  vasan_inactive,
  farsan_active,
  farsan_inactive,
  farm_active,
  farm_inactive,
};


const Sidebar = ({ onItemClick }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.data);
  
  // Get sidebar menu from Redux store
  const { sidebarMenu, isLoading: isAllSideMenuLoading, error: sidebarError } = useSelector((state) => state.sidebar);

  const [isOpen, setisOpen] = useState(false);
  const [CurrentUser, setCurrentUser] = useState(null);

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [error, setError] = useState('');
  const [selectedMenu, setselectedMenu] = useState(null);

  const verifyPassword = () => {
    const correctPassword = settings?.menuProtection?.password ?? "";
    if (passwordInput === correctPassword) {
      setIsPasswordModalOpen(false);
      setPasswordInput('');
      setError('');
      if(selectedMenu?.link){
        navigate(selectedMenu?.link);
        // Close mobile sidebar overlay if callback is provided
        if (typeof onItemClick === 'function') {
          onItemClick();
        }
      }
    } else {
      setError('Incorrect password');
    }
  };

  const handleSettingsClick = () => {
    setIsPasswordModalOpen(true);
  };

  const menuOptions = [
    {
      text: t('dashboard'),
      Icon: dashboard_inactive,
      activeIcon: dashboard_menu,
      link: '/dashboard'
    },
    {
      text: t('order'),
      Icon: order_inactive,
      activeIcon: order,
      link: '/orders'
    },
    {
      text: t('Category'),
      Icon: Category_inactive,
      activeIcon: Category_active,
      link: '/Category'
    },
    {
      text: t('menu'),
      Icon: Menu_inactive,
      activeIcon: Menu_Active,
      link: '/menu'
    },
    {
      text: t('farm'),
      Icon: farm_inactive,
      activeIcon: farm_active,
      link: '/farm'
    },
    {
      text: t('vegetable'),
      Icon: vegetable_inactive,
      activeIcon: vegetable,
      link: '/vegetable'
    },
    {
      text: t('Groceries'),
      Icon: grocery_inactive,
      activeIcon: grocery_active,
      link: '/groceries'
    },
    {
      text: t('DairyItems'),
      Icon: dairy_inactive,
      activeIcon: dairy_active,
      link: '/dairyitems'
    },
    {
      text: t('FarsanItems'),
      Icon: farsan_inactive,
      activeIcon: farsan_active,
      link: '/farsanitems'
    },
    {
      text: t('VasanItems'),
      Icon: vasan_inactive,
      activeIcon: vasan_active,
      link: '/vasanItems'
    },
    {
      text: t('Miscellaneous'),
      Icon: vasan_inactive,
      activeIcon: vasan_active,
      link: '/miscellaneous'
    },
    {
      text: "Report",
      Icon: vasan_inactive,
      activeIcon: vasan_active,
      link: '/report'
    },
    {
      text: t('setting'),
      Icon: setting_inactive,
      activeIcon: setting,
      link: '/setting'
    },
  ];

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem('CurrentUser')) || null;
    setCurrentUser(currentUser);
    
    // Fetch sidebar menu if not available in Redux
    if (!sidebarMenu || sidebarMenu.length === 0) {
      fetchSidebarMenu();
    }
  }, [sidebarMenu])

  const shortName = (fullName) => {
    const words = fullName.split(' ');
    const initials = words.map(word => word[0]).join('');
    return initials;
  };

  const onLogout = (isLogout) => {
    if (isLogout === true) {
      localStorage.clear();
      dispatch(clearSidebarMenu()); // Clear sidebar menu from Redux
      navigate('/login');
    } else {
      setisOpen(false);
    }
  }

  const handleMenuItemClick = () => {
    if (typeof onItemClick === 'function') {
      onItemClick();
    }
  };

  return (<>
    <div className='h-screen w-64 bg-gradient-to-b from-slate-50 to-white border-r border-slate-200 overflow-hidden'>
      <div className='flex flex-col h-full'>
        {/* Navigation Menu */}
        <div className='flex-1 px-4 py-6 space-y-2 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100'>
          {/* Loading State */}
            {isAllSideMenuLoading && (
            <div className="py-2 animate-pulse">
              {/* Simulate 6 menu rows */}
              {Array.from({ length: 6 }).map((_, idx) => (
                <div key={idx} className="flex items-center gap-3 px-4 py-3 rounded-xl mb-2">
                  <div className="w-6 h-6 bg-gray-200 rounded"></div>
                  <div className="h-4 w-32 bg-gray-200 rounded"></div>
                </div>
              ))}
            </div>
          )}
          
          {/* Error State */}
          {sidebarError && !isAllSideMenuLoading && (
            <div className="flex items-center justify-center py-8">
              <div className="text-center">
                <div className="text-red-500 text-sm mb-2">Error loading menu</div>
                <button 
                  onClick={() => fetchSidebarMenu()}
                  className="text-blue-600 text-sm hover:underline"
                >
                  Retry
                </button>
              </div>
            </div>
          )}
          
          {/* Menu Items */}
          {/* Fallback to hardcoded menu if Redux fails */}
          {(!sidebarMenu || sidebarMenu.length === 0) && !isAllSideMenuLoading && !sidebarError && (
            <>
              {menuOptions.map((menus, index) => {
                const isActive = location.pathname === menus.link;
                return (
                  <NavLink
                    key={index}
                    className={`group flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 hover:bg-slate-100 ${location.pathname === menus.link ? 'bg-white shadow-sm border border-slate-200' : ''}`}
                    to={menus.link}
                    onClick={handleMenuItemClick}
                  >
                    <div className={`w-6 h-6 flex items-center justify-center transition-transform duration-300 group-hover:scale-110`}>
                      <img
                        src={location.pathname === menus.link ? menus.activeIcon : menus.Icon}
                        alt={menus.text}
                        className={`w-5 h-5 transition-all duration-300 ${location.pathname === menus.link ? 'filter brightness-0' : 'opacity-70 group-hover:opacity-100'}`}
                      />
                    </div>
                    <div className={`text-sm font-semibold transition-all duration-300 ${location.pathname === menus.link
                        ? 'text-slate-900 font-semibold'
                        : 'text-slate-700 group-hover:text-slate-900'
                      }`}>
                      {menus.text}
                    </div>
                  </NavLink>
                );
              })}
            </>
          )}
          
          {/* Dynamic Menu from Redux */}
          {/* {menuOptions.map((menus, index) => {
            const isSettings = false;
            const isActive = location.pathname === menus.link;
            return (
              <React.Fragment key={index}>
                {isSettings ? (
                  <div
                    className={`group flex items-center gap-3 px-4 py-3 rounded-xl cursor-pointer transition-all duration-300 hover:bg-slate-100 ${isActive ? 'bg-white shadow-sm border border-slate-200' : ''}`}
                    onClick={() => handleSettingsClick()}
                  >
                    <div className={`w-6 h-6 flex items-center justify-center transition-transform duration-300 group-hover:scale-110`}>
                      <img
                        src={isActive ? menus.activeIcon : menus.Icon}
                        alt={menus.text}
                        className={`w-5 h-5 transition-all duration-300 ${isActive ? 'filter brightness-0' : 'opacity-70 group-hover:opacity-100'}`}
                      />
                    </div>
                    <div className={`text-sm font-semibold transition-all duration-300 ${isActive
                        ? 'text-slate-900 font-semibold'
                        : 'text-slate-700 group-hover:text-slate-900'
                      }`}>
                      {menus.text}
                    </div>
                  </div>
                ) : (
                  <NavLink
                    className={`group flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 hover:bg-slate-100 ${location.pathname === menus.link ? 'bg-white shadow-sm border border-slate-200' : ''}`}
                    to={menus.link}
                  >
                    <div className={`w-6 h-6 flex items-center justify-center transition-transform duration-300 group-hover:scale-110`}>
                      <img
                        src={location.pathname === menus.link ? menus.activeIcon : menus.Icon}
                        alt={menus.text}
                        className={`w-5 h-5 transition-all duration-300 ${location.pathname === menus.link ? 'filter brightness-0' : 'opacity-70 group-hover:opacity-100'}`}
                      />
                    </div>
                    <div className={`text-sm font-semibold transition-all duration-300 ${location.pathname === menus.link
                        ? 'text-slate-900 font-semibold'
                        : 'text-slate-700 group-hover:text-slate-900'
                      }`}>
                      {menus.text}
                    </div>
                  </NavLink>
                )}
              </React.Fragment>
            );
          })} */}
          {sidebarMenu && sidebarMenu.length > 0 && !isAllSideMenuLoading && sidebarMenu
          ?.filter((m) => m.isActive)
          ?.sort((a, b) => a.order - b.order)
          .map((menus) => {
            const isActive = location.pathname === menus.link;
            // const isSettings = menus.link === "/setting"; // special case
            const currentLang = i18n.language || "en";

            return (
              <React.Fragment key={menus._id}>
                {/* {isSettings ? ( */}
                {menus?.isProtected ? (
                  <div
                    className={`group flex items-center gap-3 px-4 py-3 rounded-xl cursor-pointer transition-all duration-300 hover:bg-slate-100 ${
                      isActive ? "bg-white shadow-sm border border-slate-200" : ""
                    }`}
                    onClick={() => {
                      setselectedMenu(menus);
                      handleSettingsClick();
                    }}
                  >
                    <div className="w-6 h-6 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                      <img
                        src={iconsMap[isActive ? menus.activeIcon : menus.icon]}
                        alt={menus.text.en}
                        className={`w-5 h-5 transition-all duration-300 ${
                          isActive
                            ? "filter brightness-0"
                            : "opacity-70 group-hover:opacity-100"
                        }`}
                      />
                    </div>
                    <div
                      className={`text-sm font-semibold transition-all duration-300 ${
                        isActive
                          ? "text-slate-900 font-semibold"
                          : "text-slate-700 group-hover:text-slate-900"
                      }`}
                    >
                      {menus.text[currentLang]}
                    </div>
                  </div>
                ) : (
                  <NavLink
                    className={`group flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 hover:bg-slate-100 ${
                      isActive ? "bg-white shadow-sm border border-slate-200" : ""
                    }`}
                    to={menus.link}
                    onClick={handleMenuItemClick}
                  >
                    <div className="w-6 h-6 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                      <img
                        src={iconsMap[isActive ? menus.activeIcon : menus.icon]}
                        alt={menus.text.en}
                        className={`w-5 h-5 transition-all duration-300 ${
                          isActive
                            ? "filter brightness-0"
                            : "opacity-70 group-hover:opacity-100"
                        }`}
                      />
                    </div>
                    <div
                      className={`text-sm font-semibold transition-all duration-300 ${
                        isActive
                          ? "text-slate-900 font-semibold"
                          : "text-slate-700 group-hover:text-slate-900"
                      }`}
                    >
                      {menus.text[currentLang]}
                    </div>
                  </NavLink>
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Logout Section */}
        <div className='p-4 border-t border-slate-200/50 flex-shrink-0'>
          <div
            className="group flex items-center gap-3 px-4 py-3 rounded-xl cursor-pointer transition-all duration-300 hover:bg-red-50 hover:shadow-sm hover:border-red-200"
            onClick={() => { setisOpen(true) }}
          >
            <div className="w-6 h-6 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
              <img
                src={Logout_inactive}
                alt='logout'
                className="w-5 h-5 opacity-70 group-hover:opacity-100 transition-all duration-300"
              />
            </div>
            <div className="text-sm font-medium text-slate-600 group-hover:text-red-600 transition-all duration-300">
              {t('logout')}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <LogoutModal isOpen={isOpen} onClose={onLogout}></LogoutModal>
    </div>

    {isPasswordModalOpen && (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
        <div className="bg-white rounded-2xl p-6 shadow-2xl w-96 border border-gray-100">
          <div className="text-center mb-6">
            <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-xl mx-auto mb-4 flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-800">{t('passwordlbl')}</h2>
          </div>
          <input
            type="password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl outline-none focus:border-primary transition-all duration-300"
            placeholder={t('passwordlbl')}
          />
          {error && (
            <div className="flex items-center mt-3 text-red-500 text-sm">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {error}
            </div>
          )}
          <div className="flex gap-3 mt-6">
            <button
              onClick={() => {
                setIsPasswordModalOpen(false);
                setselectedMenu(null);
                setPasswordInput('');
                setError('');
              }}
              className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 transition-all duration-300"
            >
              {t('btnCancel')}
            </button>
            <button
              onClick={verifyPassword}
              className="flex-1 px-4 py-3 bg-gradient-to-r from-primary to-secondary text-white rounded-xl font-medium hover:shadow-lg transition-all duration-300 transform hover:scale-[1.02]"
            >
              {t('btnsubmit')}
            </button>
          </div>
        </div>
      </div>
    )}

  </>)
}

export default Sidebar;